import React from 'react';
import AudioScene from 'game/scenes/test/AudioScene';

import GameService from 'services/Game.service';
import { Layout, Game } from 'components';

export default function AudioScenePage() {
  return (
    <GameService>
      <Layout>
        <Game
          config={{
            scene: [AudioScene],
            physics: {
              arcade: {
                gravity: { y: 0 },
              },
            },
          }}
        />
      </Layout>
    </GameService>
  );
}
